import { render, staticRenderFns } from "./notice-detail.vue?vue&type=template&id=64a01b64&scoped=true"
import script from "./notice-detail.vue?vue&type=script&lang=js"
export * from "./notice-detail.vue?vue&type=script&lang=js"
import style0 from "./notice-detail.vue?vue&type=style&index=0&id=64a01b64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a01b64",
  null
  
)

export default component.exports